import React from 'react'

const OwnerDefectReport = () => {
  return (
    <div className="row">
  <div className="col-lg-12">
    <div className="card">
      <div className="card-body">
        {/* <div className="row">
          <div className="col-md-12">
            <div className="checklist-title-bx">
              <h4 style={{ marginBottom: 0 }}>OSS XXXXX Site Office</h4>
              <p>site office address:</p>
              <p>Tel (Office): (xx)-xx-xxxx xxxx</p>
              <p>email: xxxxxxxxxxxxxxxxxx</p>
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-12">
            <div className="appraisal-report-table-responsive">
              <table className="assessment-table" cellSpacing={0}>
                <tbody>
                  <tr>
                    <td className="td-s1 td-s1-heading" colSpan={6}>
                      <p className="s1">OWNER’S DEFECT REPORT</p>
                    </td>
                  </tr>
                  <tr>
                    <td className="hd-s2 pd10 w150">
                      {" "}
                      <p>Hull Number</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Hull Number"
                        defaultValue=""
                      />
                    </td>
                    <td className="hd-s2 pd10 w150">
                      <p>Issue Date</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Enter Issue Date"
                        defaultValue=""
                      />
                    </td>
                    <td className="hd-s2 pd10 w150">
                      {" "}
                      <p>Defect Number</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Defect Number"
                        defaultValue=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="hd-s2 pd10 w150">
                      <p>Issued By</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Issued By"
                        defaultValue=""
                      />
                    </td>
                    <td className="hd-s2 pd10 w150">
                      {" "}
                      <p>To</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="To"
                        defaultValue=""
                      />
                    </td>
                    <td className="hd-s2 pd10 w150">
                      <p>CC</p>
                    </td>
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="CC"
                        defaultValue=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="hd-s2 pd10">
                      {" "}
                      <p>Location</p>
                    </td>
                    <td colSpan={6} className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Location"
                        defaultValue=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="hd-s2 pd10">
                      {" "}
                      <p>Subject</p>
                    </td>
                    <td colSpan={6} className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Subject"
                        defaultValue=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="td-s1 td-s1-heading" colSpan={6}>
                      <p className="s1">DESCRIPTION</p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={6} className="tb-input-value">
                      <textarea
                        className="form-control"
                        placeholder=""
                        defaultValue={""}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="td-s1 td-s1-heading" colSpan={6}>
                      <p className="s1">PHOTOS</p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={6} className="tb-input-value">
                      <div className="photo-section">
                        <div className="image-upload">
                          <img src="assets/images/CruiseShip.jpg" alt="" />
                        </div>
                        <div className="image-upload">
                          <img src="assets/images/CruiseShip.jpg" alt="" />
                        </div>
                        <div className="image-upload">
                          <img src="assets/images/CruiseShip.jpg" alt="" />
                        </div>
                        <div className="image-upload">
                          <img src="assets/images/CruiseShip.jpg" alt="" />
                        </div>
                        <div className="image-upload">
                          <img src="assets/images/CruiseShip.jpg" alt="" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <table className="mrt10 mt-4 wd100">
                  <tbody>
                    <tr>
                      <td className="hd-b" colSpan={5}>
                        <p>BUILDER’S REPLY : (within 5 days after issuance)</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={5} className="input-textarea">
                        <textarea
                          className="form-control"
                          placeholder=""
                          defaultValue={""}
                        />
                      </td>
                    </tr>
                    <tr className="bottom-sig-tr2-box ">
                      <td className="input-td">
                        <p className="s2  mt-4">Signature</p>
                      </td>
                      <td>
                        <p className="s1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </p>
                      </td>
                      <td className="w50" />
                      <td className="input-td">
                        <p className="s2  mt-4">DATE</p>
                      </td>
                      <td>
                        <p className="s1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-lg-6">
                <table className="mrt10 mt-4 wd100">
                  <tbody>
                    <tr>
                      <td className="hd-b">
                        <p>VERIFIED</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="input-textarea" colSpan={5}>
                        <textarea
                          className="form-control"
                          placeholder=""
                          defaultValue={""}
                        />
                      </td>
                    </tr>
                    <tr className="bottom-sig-tr2-box mrt10">
                      <td className="input-td">
                        <p className="s2  mt-4">Signature</p>
                      </td>
                      <td>
                        <p className="s1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </p>
                      </td>
                      <td className="w50" />
                      <td className="input-td">
                        <p className="s2  mt-4">DATE</p>
                      </td>
                      <td>
                        <p className="s1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-12 text-left ">
                <a
                  href="ship-inspection-progress-list.php"
                  className="btn btn-success"
                  style={{
                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                    borderColor: "#2b5a7e"
                  }}
                >
                  Submit
                </a>
                <button
                  type="reset"
                  className="btn btn-danger ms-3"
                  style={{
                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                    borderColor: "#2b5a7e"
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default OwnerDefectReport